module.exports = __webpack_public_path__ + "img/2021年度优秀基层党组织.ae442263.jpg";